<form [formGroup]="form" class="flex flex-col gap-4">
  <div class="flex items-center gap-4 p-4 rounded-md bg-emerald-50 border border-emerald-100">
    <div class="text-2xl font-bold text-emerald-700 shrink-0 whitespace-nowrap">
      {{ freedAmount() | currencyFormat }}
    </div>
    <div class="flex flex-col gap-1 text-body-sm-500 text-surface-700">
      <span>freed and currently sitting in the deal pool.</span>
      <span class="text-body-sm-400 text-surface-600">
        You can move some/all of it to another unlocked addendum, or dismiss to leave it in the pool.
      </span>
    </div>
  </div>

  <div class="grid grid-cols-3 gap-3">
    <div class="flex flex-col gap-1 p-3 rounded-md bg-surface-50 border border-surface-100">
      <span class="text-body-xs-500 text-surface-500 uppercase tracking-wide">Pool Total</span>
      <span class="text-body-700 text-surface-800">{{ poolTotal() | currencyFormat }}</span>
    </div>
    <div class="flex flex-col gap-1 p-3 rounded-md bg-surface-50 border border-surface-100">
      <span class="text-body-xs-500 text-surface-500 uppercase tracking-wide">Applied</span>
      <span class="text-body-700 text-surface-800">{{ applied() | currencyFormat }}</span>
    </div>
    <div class="flex flex-col gap-1 p-3 rounded-md bg-emerald-50 border border-emerald-100">
      <span class="text-body-xs-500 text-emerald-700 uppercase tracking-wide">Max Applicable</span>
      <span class="text-body-700 text-emerald-700">{{ maxApplicable() | currencyFormat }}</span>
    </div>
  </div>

  <div class="flex flex-col gap-1">
    <label class="text-body-sm-500 text-surface-700"> Amount to Reallocate <span class="text-red-500">*</span> </label>
    <div class="flex items-center gap-2">
      <currency-input-field
        class="flex-1"
        formControlName="amount"
        placeholder="Enter Amount"
        [currencySymbol]="currencySymbol()"
        styleClass="flex-1"
        [min]="0"
        [max]="maxApplicable()"
      />
      <p-button type="button" label="Max" severity="secondary" size="small" (onClick)="setMaxAmount()" />
    </div>
    <small class="text-body-xs-400 text-surface-500">Any amount you don't reallocate stays in the pool.</small>
    @if (form.get('amount')?.hasError('max') && form.get('amount')?.touched) {
      <small class="text-red-500">Amount cannot exceed max applicable incentive</small>
    }
  </div>

  <div class="flex flex-col gap-1">
    <label class="text-body-sm-500 text-surface-700"> Target Addendum <span class="text-red-500">*</span> </label>
    <generic-dropdown
      class="w-full"
      placeholder="Select target addendum"
      [allowSearch]="true"
      [items]="addendums()"
      formControlName="targetAddendumId"
    />
    <small class="text-body-xs-400 text-surface-500">Only unlocked addendums on this deal are listed.</small>
  </div>

  <div class="flex flex-col gap-2">
    <label class="text-body-sm-500 text-surface-700"> Distribution Method <span class="text-red-500">*</span> </label>
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      @for (option of methodOptions; track option.value) {
        @let isSelected = form.get('method')?.value === option.value;
        <label
          [for]="'reallocation-method-' + option.value"
          class="flex items-start gap-3 p-3 rounded-md border cursor-pointer transition-colors"
          [class.border-emerald-600]="isSelected"
          [class.bg-emerald-50]="isSelected"
          [class.border-surface-200]="!isSelected"
          [class.hover:border-surface-300]="!isSelected"
        >
          <p-radioButton
            [inputId]="'reallocation-method-' + option.value"
            [value]="option.value"
            formControlName="method"
          />
          <div class="flex flex-col gap-1">
            <span class="text-body-sm-600 text-surface-800">{{ option.label }}</span>
            <span class="text-body-xs-400 text-surface-500">{{ option.description }}</span>
          </div>
        </label>
      }
    </div>
  </div>

  @if (previewTargetAddendumId(); as targetId) {
    <dsm-addendum-incentive-preview [addendumId]="targetId" [amount]="previewAmount()" [method]="previewMethod()" />
  }
</form>
